import { RefObject } from 'react';

const CARD_NUMBER_TYPES = new Set([
  'creditcard_number',
  'creditcard_visa',
  'card_number',
  'creditcard_mastercard',
]);

const inputMaskerMap: {
  [key: string]: {
    pattern: RegExp | null;
    mask: (value: string) => string;
  };
} = {
  amount: {
    pattern: /^[.\d,]+$/,
    mask: (value) => {
      return value.replaceAll(/[^.\d,]/g, '').trim();
    },
  },
  cardHolder: {
    pattern: /^[a-zA-Z\s]+$/,
    mask: (value) => {
      return value.replaceAll(/[^a-zA-Z\s]/g, '').slice(0, 50);
    },
  },
  cvv: {
    pattern: null,
    mask: (value) => {
      if (value.length > 4) {
        return value.substring(0, 4);
      }

      return value;
    },
  },
  identification_number: {
    pattern: null,
    mask: (value) => {
      const hasOnlyIntegers = !!value.match(/^\d+$/);

      if (!hasOnlyIntegers) {
        return value.substring(0, value.length - 1);
      }

      if (value.length > 11) {
        return value.substring(0, 11);
      }

      return value;
    },
  },
  integer: {
    pattern: null,
    mask: (value) => value.replaceAll(/\D/g, ''),
  },
};

export const maskInput = (
  inputRef: RefObject<HTMLInputElement | null>,
  name: string,
  type: string,
) => {
  const inputMasker = inputMaskerMap[name];

  if (!inputRef.current) return;

  if (inputMasker) {
    if (inputMasker.pattern) {
      inputRef.current.pattern = inputMasker.pattern.toString();
    }

    inputRef.current.value = inputMasker.mask(inputRef.current.value);
  }

  if (CARD_NUMBER_TYPES.has(type)) {
    inputRef.current.value = inputRef.current.value
      .replaceAll(/[^\dA-Z]/g, '')
      .replaceAll(/(.{4})/g, '$1 ')
      .trim();

    if (inputRef.current.value.length > 23) {
      inputRef.current.value = inputRef.current.value.substring(0, 23);
    }
  }
};
